import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { auth } from "../../../config/firebase";
import { useStateValue } from "../../context/StateValueContext";

export default function SignOutSignIn() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [{ user }] = useStateValue();

  useEffect(() => {
    const handleSignOutAndRedirect = async () => {
      // Build redirect URL with preserved msg parameter
      const msgParam = searchParams.get("msg");
      const redirectUrl = msgParam ? `/signin?msg=${encodeURIComponent(msgParam)}` : "/signin";

      // Sign out if user is currently signed in
      console.log('user', user);
      if (user) {
        console.log('signing out');
        try {
          await auth.signOut();
        } catch (error) {
          console.error("Error signing out:", error);
        }
      }

      // Redirect to signin page
      navigate(redirectUrl, { replace: true });
    };

    handleSignOutAndRedirect();
  }, [navigate, searchParams, user]);

  return null;
}
